import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { deleteItems, updateStateData } from "../../../Store/actions";
import { Box } from "@mui/material";
import { SpaceBetweenStack } from "../../../components/commonComponents/StyledComponents/styled";
import ActionButton from "../../../components/commonComponents/Buttons/ActionButton";
import { checkUserDetailsFromCookie, checkUserRole } from "../../../api_calls/userManagement";
import { useNavigate } from "react-router-dom";
import { createCookie, deleteCookie } from "../../../api_calls/requestConfig";
import { listLoopCampaigns } from "../../../api_calls/loopCampaign";
import FilterPanel from "../../../components/commonComponents/Filters/FilterPanel";

const LoopsListFilter = () => {
  const loopCampaigns = useSelector((state) => state.userSelections);
  const verifyUserRoleName = checkUserRole();
  const navigate = useNavigate();

  const checkUserDetails = checkUserDetailsFromCookie();
  let userDetailObj = {};
  if (checkUserDetails.success === true) {
    userDetailObj = checkUserDetails.user_detail;
  }

  const dispatchAction = useDispatch();

  const saveLoopFilters = (filters) => {
    const filterValues = {
      loop_name: filters.loop_name || [],
      visual_name: filters.visual_name || [],
      loop_company_filter: filters.owner || [],
      status_filter: filters.status || [],
      loop_store_filter: filters.store_name || [],
      // loop_prioritization: disabled for pre_prod deploy — inStore not ready
      // campaign_type: filters.campaign_type || null,
    };

    const noFiltersSelected =
      (!filterValues.loop_name || filterValues.loop_name.length === 0) &&
      (!filterValues.visual_name || filterValues.visual_name.length === 0) &&
      (!filterValues.loop_company_filter || filterValues.loop_company_filter.length === 0) &&
      (!filterValues.status_filter || filterValues.status_filter.length === 0) &&
      // loop_prioritization: reverted for pre_prod deploy — inStore not ready
      // (!filterValues.loop_store_filter || filterValues.loop_store_filter.length === 0) &&
      // (!filterValues.campaign_type);
      (!filterValues.loop_store_filter || filterValues.loop_store_filter.length === 0);

    if (noFiltersSelected) {
      // If nothing is selected, clear existing filters and return
      clearfilters();
      return;
    }
    // Persist to Redux for later retrieval (e.g. PPT generation)
    dispatchAction(
      updateStateData({
        loop_list_filters: filterValues,
        loop_list_filter_applied: true,
      })
    );
    // Persist to cookies for session persistence
    createCookie("loop_list_filters", JSON.stringify(filterValues));
    // Reload loops (reset to page 1 but keep page size)
    listLoopCampaigns(0, loopCampaigns.loops_pagination.pageSize);
  };

  const clearfilters = () => {
    // Delete the stored cookie
    deleteCookie("loop_list_filters", true);
    // Remove filters from Redux and reset flags
    dispatchAction(deleteItems(["loop_list_filters", "filtered_loops_list", "loop_list_filter_applied"]));
    // Reload unfiltered list
    listLoopCampaigns(0, loopCampaigns.loops_pagination.pageSize);
  };

  // filters config
  const loopFiltersConfig = React.useMemo(
    () => [
      {
        key: "loop_name",
        label: "Campaign Name",
        type: "multi",
        options: () =>
          typeof loopCampaigns.loop_names_info !== "undefined"
            ? loopCampaigns.loop_names_info.loop_names_list
            : [],
      },
      {
        key: "visual_name",
        label: "Visual Name",
        type: "multi",
        options: () =>
          typeof loopCampaigns.visual_names_info !== "undefined"
            ? loopCampaigns.visual_names_info.visual_names_list
            : [],
      },
      {
        key: "status",
        label: "Progress",
        disableSearch: true,
        type: "multi",
        disableSearch: true,
        selectionParam: "label",
        options: () => [
          { value: 1, label: "Active" },
          { value: 2, label: "Scheduled" },
          { value: 3, label: "Completed" },
          { value: 4, label: "Stopped" },
        ],
      },
      {
        key: "owner",
        label: "Owner",
        type: "multi",
        options: () => loopCampaigns?.companies_info,
      },
      {
        key: "store_name",
        label: "Stores",
        type: "multi",
        selectionParam: "cyreen_id",
        options: () => loopCampaigns?.store_names_info?.store_names_list,
      },
      // loop_prioritization: disabled for pre_prod deploy — backend not ready
      // {
      //   key: "campaign_type",
      //   label: "Campaign Type",
      //   disableSearch: true,
      //   type: "single",
      //   selectionParam: "value",
      //   options: () => [
      //     { value: 'commercial', label: 'Commercial' },
      //     { value: 'unlimited', label: 'Unlimited' },
      //   ],
      // },
      // {
      //   key: "campaign_type",
      //   label: "Campaign Type",
      //   type: "single",
      //   selectionParam: "value",
      //   options: () => [
      //     { value: 'commercial', label: 'Commercial' },
      //     { value: 'unlimited', label: 'Unlimited' },
      //   ],
      // },
    ],
    [loopCampaigns]
  );

  return (
    typeof loopCampaigns.loop_names_list !== "undefined" && (
      <>
        {/* ----------- filter row 1 -------- */}
        <Box>
          <SpaceBetweenStack
            direction={"row"}
            spacing={2}
            width={"100%"}
            justifyContent={"space-between"}
            display={"flex"}
          >
            <FilterPanel
              filtersConfig={loopFiltersConfig}
              applyFilterFunc={saveLoopFilters}
              clearFilterFunc={clearfilters}
              initiallyAppliedVals={loopCampaigns.loop_list_filters}
            />
            {/* ------ overview should be hidden for brand user ----- */}
            {verifyUserRoleName.user_role !== "Brand" && (
              <ActionButton
                onClick={(e) => {
                  // e.preventDefault();
                  navigate("/check-campaigns/loop-overview");
                }}
                label={"Overview"}
              />
            )}
          </SpaceBetweenStack>
        </Box >
      </>
    )
  );
};

export default LoopsListFilter;
